// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"72545d25","513":"2d4d50bd","703":"07204603"}[chunkId] + ".chunk.js";
};